import '../../wish-list/components/wish-list-update-product-button';
import '../product-card-display/product-card-metadata.display';
import store from '../../../store/store';
import { BaseComponent } from '../../base-component/base-component';
import { CtaTypeLabel } from '../product.interface';
import { DesignType } from '../../cart/add-to-cart';
import { ProductCardData } from '../product-card-display';
import { ViewTypeLabel } from '../../search/interfaces/search.interface';
import { booleanConverter } from '../../../common/converters';
import { connect } from 'pwa-helpers';
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { WishList } from '../../wish-list/interfaces/wish-list-items.interface';
import { getProductUrl } from '../utils/product-card.util';
import { emitProductAnalyticsEvent, emitProgramFamilyAnalyticsEvent } from '../utils/product-card.analytics.util';
import { SEG_LOWER, formattedJoin } from '../../../common/utils/util';

@customElement('mhecomm-k12-product-list-display')
export class K12ProductListDisplay extends connect(store)(BaseComponent) {
  static styles = [
    css`
      .add-to-cart-container {
        flex-grow: 1;
        order: 2;
      }
      
      .metadata-container {
        flex: 0 0 auto;
        line-height: 1.5;
        width: 50%;
      }
      
      .update-product-button-container {
        flex: 0 0 auto;
        margin-left: 1rem;
        order: 3;
        width: auto;
      }
      
      @media (max-width: 992px) {
        .add-to-cart-container {
          flex: 0 1 100%;
          order: 3;
        }
        
        .metadata-container {
          flex: 1 0 85%;
        }
        
        .update-product-button-container {
          flex: 1 0 10%;
          margin-left: 0;
          order: 2;
          padding: 0;
          text-align: end;
        }
      }
    `,
  ];

  @property({ type: Object })
  product?: ProductCardData;

  @property({ type: Boolean })
  isWishListProduct: boolean = false;

  @property({ type: Object })
  wishList?: WishList;

  @property()
  addToCartPageType?: string;

  @property({ type: Boolean })
  showBusinessLabelType = true;

  @property({ type: String })
  businessLabelType = 'Product';

  @property({ type: String })
  cta = CtaTypeLabel.VIEW_ITEM;

  @property({ type: String })
  ctaLabel = 'Add to Cart';

  @property({ converter: booleanConverter })
  showProductWishList?: boolean = false;

  @property({ type: Boolean })
  isWishListItemCardView = false;

  renderComp() {
    return this.product
      ? html` <div
          class="position-relative d-flex flex-row flex-wrap justify-content-lg-between align-items-lg-center text-left gx-2"
        >
          <div class="metadata-container">
              <mhecomm-product-card-metadata-display
                .product="${this.product}"
                programId="${this.product?.partsOf?.value!}"
                programTitle="${this.product?.partsOf?.label!}"
                businessLabelType=${this.businessLabelType}
                ?showBusinessLabelType=${this.showBusinessLabelType}
                ?showProgramFamily=${true}
                ?showMHID=${true}
                ?showGrades=${true}
                ?showCopyright=${true}
                titleWeight="semibold"
                titleHref="${getProductUrl(this.product)}"
                .titleClickListener=${(e: Event) => {
                  e.preventDefault();
                  const target = e.currentTarget as HTMLAnchorElement;
                  emitProductAnalyticsEvent(this, this.product!, SEG_LOWER, 'mhecomm-k12-product-list');
                  window.location.href = target.href;
                }}
                .programFamilyClickListener=${(e: Event) => {
                  e.preventDefault();
                  const target = e.currentTarget as HTMLAnchorElement;
                  emitProgramFamilyAnalyticsEvent(this, this.product!);
                  window.location.href = target.href;
                }}
              ></mhecomm-product-card-metadata-display>
          </div>
          <div class="add-to-cart-container">
            <div class="d-lg-flex gap-lg-3 align-items-lg-center justify-content-lg-end">
              <mhecomm-add-to-cart
                view=${ViewTypeLabel.LIST}
                text=${this.ctaLabel}
                productTitle=${this.product?.title!}
                ?isWishListProduct=${this.isWishListProduct}
                .wishList=${this.wishList!}
                addToCartPageType=${this.addToCartPageType!}
                netPrice=${this.product?.netPrice}
                listPrice=${this.product?.totalPrice ? this.product?.totalPrice : 0}
                ?isWishListItemCardView=${this.isWishListItemCardView}
                ?showQuantity=${true}
                quantity=${this.product?.quantity!}
                businessUnit=${SEG_LOWER}
                isbn=${this.product.isbn || this.product.mhid!}
                isbn13=${this.product?.isbn13!}
                .contributors=${formattedJoin(this.product?.contributors!)}
                .copyRightYear=${this.product?.copyRightYear!}
                .edition=${this.product?.edition!}
                .gradeLevel=${this.product?.gradeLevels!}
                designMode=${DesignType.PRIMARY}
                .programSourceId=${this.product?.programSourceId}
              >
              </mhecomm-add-to-cart>
            </div>
          </div>
          ${this.getWishListUpdateProductButton()}
        </div>`
      : nothing;
  }

  /**
   * Returns the wish list update product button.
   */
  private getWishListUpdateProductButton() {
    if (!this.showProductWishList) {
      return nothing;
    }

    return html`
      <div class="update-product-button-container">
        <mhecomm-wish-list-update-product-button .product=${this.product}></mhecomm-wish-list-update-product-button>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-k12-product-list-display': K12ProductListDisplay;
  }
}